import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from "react-router-dom";
// import RankingsResults from './rankingsResults';
import PlayerFilters from './playerFilters';
import PlayersTable from '../mockDraft/runningDraft/playersTable';
import RankingsSummary from './rankingsSummary';
import ActionHeader from '../../components/actionHeader';
import RefreshIcon from '../../assets/icons/refresh.svg';
// import LizardLogo from '../../assets/images/sponsors/lizard-skins.png';
import { Wrapper, Row, Col, Container } from '../../components/layout';
import { PrimaryButton, SecondaryButton, OutlineButtonIcon } from '../../components/buttons';
import Modal, { ModalContent, SaveItemModal } from '../../components/modal';
import { fetchSuccess } from '../../actions/players';
import useFetchUrl from '../../lib/hooks/useFetchUrl';
import LoadingIndicator from '../../components/loading';
import { TabsWhenMobile } from '../../components';
import { mobileBreakpoint, baseUrl } from '../../lib';
import { saveItemToWP } from '../../actions/api';
import useGetUserData from '../../lib/hooks/useGetUserData';
import { sponsorsStore } from '../../store';

export const initialFilters = {
    positions: '',
    leagues: '',
    availability: 'Available',
    search: '',
}

function handleSetFilter(oldFilters, selectedOption, filterName){
    return {...oldFilters, [filterName]: selectedOption};
}

const RankingsWrapper = styled(Wrapper)`
    padding-top: 0px;
`;

const H1 = styled.h1`
    margin-top: 20px;
    margin-bottom: 0px;
`

// const Text = styled.h2`
//     margin: 0;
//     font-weight: 400;
//     font-size: 16px;
//     line-height: 19px;
//     margin-right: 20px;
// `

const FirstColumn = styled(Col)`
    flex: 0 0 69%;
    align-self: flex-start;
    flex-wrap: wrap;
    @media(max-width: 900px){
        flex: 0 0 100%;
    }
`;

const SecondColumn = styled(Col)`
    flex: 0 0 31%;
    align-self: flex-start;
    flex-wrap: wrap;
    @media(max-width: 900px){
        flex: 0 0 100%;
    }
`;

const ExitIconContainer = styled.div`
    position: absolute;
    top: 27px;
    right: 27px;
    cursor: pointer;
    @media(max-width: 1390px){
        visibility: hidden;
        display: none;
    }
`;

const FinishedContainer = styled(Container)`
    margin-top: 100px;
    width: 100%;
`

async function saveRankingsToAccount(data, title, userId, history, setSubmitting){
    setSubmitting(true);
    await saveItemToWP(data, 'user_rankings', title, userId);
    setSubmitting(false);
    history.push('/my-rankings');
}

function FinishedRankings({ handleSave, handleRestart, handleShare, userCanSave }){
    return(
        <FinishedContainer>
            <Row margin="0 0 20px 0" justifyContent="center"><h3>Your rankings are complete!</h3></Row>
            <Row margin="0 0 40px 0" justifyContent="center">
                <Col>
                    <PrimaryButton margin="0 20px 0 0" onClick={handleShare}>Share</PrimaryButton>
                    {userCanSave && <SecondaryButton onClick={handleSave}>Save</SecondaryButton>}
                </Col>
            </Row>
            <Row justifyContent="center">
                <Col>
                    <OutlineButtonIcon onClick={handleRestart} icon={RefreshIcon}>Restart</OutlineButtonIcon>
                </Col>
            </Row>
        </FinishedContainer>
    );
}

function RankingsBuilder({ rankedPlayers, setRankedPlayers, setStep }) {
    let history = useHistory();
    
    const { state: { rankingsBuilder } } = useContext(sponsorsStore);
    const [ submitting, setSubmitting ] = useState(false);
    const [ filtersState, setFilter ] = useState(initialFilters);
    const [ title, setTitle ] = useState('');
    const [ isExitModalOpen, setExitModalOpen ] = useState(false);
    const [ isSaveModalOpen, setSaveModalOpen ] = useState(false);
    const [ activeTab, setActiveTab ] = useState(0);
    const { userId, username, userCanSave } = useGetUserData();
    const isMobile = useMediaQuery({maxWidth: mobileBreakpoint});
    const [ players, loading ] = useFetchUrl(`players/fc/players-2025.json`, fetchSuccess);
    const draggablePlayers = rankedPlayers.map((player) => ({...player, id: player.id}));

    const handleAddPlayer = (newPlayer) => {
        const newList = [...rankedPlayers, newPlayer];
        setRankedPlayers(newList);        
    }
    const handleRemovePlayer = (playerId) => {
        const newList = rankedPlayers.filter((player) => player.id !== playerId);
        setRankedPlayers(newList);
    }

    return (
    <RankingsWrapper>
        <Modal title="Quit the rankings builder" isOpen={isExitModalOpen} closeModal={() => setExitModalOpen(false)}>
            <Row>
                <ModalContent>
                    {userCanSave ? 'You can save your rankings in their current position or exit without saving to discard your current rankings.' :
                    'Your progress will be lost, are you sure you want to exit ?'}
                </ModalContent>
            </Row>
            <Row justifyContent="space-between">
                {userCanSave && <PrimaryButton onClick={()=> {setExitModalOpen(false); setSaveModalOpen(true);}} disabled={!draggablePlayers.length}>Save & Exit</PrimaryButton>}
                <SecondaryButton padding="10px 50px" onClick={() => window.location.replace(baseUrl)}>{userCanSave ? 'Exit without saving' : 'Exit'}</SecondaryButton>
            </Row>
        </Modal>
        <SaveItemModal
            title={title}
            setTitle={setTitle}
            isOpen={isSaveModalOpen}
            submitting={submitting}
            item="rankings"
            saveItem={() => saveRankingsToAccount({ rankedPlayers, username }, title, userId, history, setSubmitting)}
            handleModalOpen={setSaveModalOpen}
        />
        <ActionHeader
            heading="Rankings Builder"
            subHeading=""
            sponsorLogo={rankingsBuilder.url}
            handleOpenExitModal={() => setExitModalOpen(true)}
            isCdnSponsor
        >
            <OutlineButtonIcon margin="0 20px 0 0" onClick={() => setRankedPlayers([])} icon={RefreshIcon}>Restart</OutlineButtonIcon>
            <PrimaryButton margin={userCanSave ? "0 20px 0 0" : "0"} onClick={()=> setStep(2)} disabled={!draggablePlayers.length}>Share</PrimaryButton>
            {userCanSave && <SecondaryButton disabled={!draggablePlayers.length} onClick={() => setSaveModalOpen(true)}>Save</SecondaryButton>}
            <ExitIconContainer>
                <svg width="35px" height="35px" viewBox="0 0 35 35" version="1.1" onClick={()=>setExitModalOpen(true)}>
                    <g id="Icon/close/2px">
                        <path d="M19.0909 0L0 19.0909L19.0909 0Z" transform="translate(7.954545 7.954545)" id="Path-3-Copy-4" fill="none" stroke="#FFFFFF" strokeWidth="2" />
                        <path d="M19.0909 19.0909L0 0L19.0909 19.0909Z" transform="translate(7.954545 7.954545)" id="Path-3-Copy-5" fill="none" stroke="#FFFFFF" strokeWidth="2" />
                    </g>
                </svg>
            </ExitIconContainer>
        </ActionHeader>

        {loading ? <LoadingIndicator /> :
            <>
                {!isMobile && <Row margin="20px 0 0 0">
                    <Col size="70%">
                        <PlayerFilters
                            filtersState={filtersState}
                            setFilter={(opt, filterName) => setFilter(handleSetFilter(filtersState, opt, filterName))}
                        />
                    </Col>
                </Row>}
                <TabsWhenMobile setActiveTab={setActiveTab} activeTab={activeTab} data={["FC Rankings", "Your Rankings"]}>
                    <FirstColumn>
                        {isMobile ? <PlayerFilters
                            filtersState={filtersState}
                            setFilter={(opt, filterName) => setFilter(handleSetFilter(filtersState, opt, filterName))}
                        /> : <H1>FC Rankings</H1>}
                        <PlayersTable
                            filters={filtersState}
                            players={players}
                            selectedPlayers={draggablePlayers}
                            handleAddPlayer={handleAddPlayer}
                            isMyTurn={true}
                            actionButtonLabel="Add"
                            FinishedRankings={
                                <FinishedRankings handleShare={()=>setStep(2)} handleSave={()=>setSaveModalOpen(true)} handleRestart={()=>setRankedPlayers([])} userCanSave={userCanSave}/>
                            }
                        />
                    </FirstColumn>
                    <SecondColumn>
                        {!isMobile && <H1>Your Rankings</H1>}
                        <RankingsSummary rankedPlayers={draggablePlayers} setRankedPlayers={setRankedPlayers} handleRemovePlayer={handleRemovePlayer}/>
                    </SecondColumn>
                </TabsWhenMobile>
            </>
        }
    </RankingsWrapper>);
}

export default RankingsBuilder;